import { WeekPlanApi } from '../api/WeekPlanApi'

import { ExtraApi } from '../api/ExtraApi'
import { Menu } from '../core/Menu'
import { container } from '../services/container'

export const menuStore = {
	state: {
    	menu: null,
    	loading: false,
    	active: true,
    	loadingPromise: null,

		freeExtra: { 
	      active: false, 
	      ids: null,
	      id: null,
	      image: '',
	      title: '',
	      loaded: false,
	      config: [
	      	  {  
              	menuId: 227,  
              	extraId: 566  
              },
              {  
              	menuId: 228,  
              	extraId: 575  
              }
	      ]
	    }
	},

	config: {
    	boxTagName: 'box-mixed'
    },

    isMenuAvailable() {
			if (this.state.menu == null) {
        return false;
      }

      return true; // tempfix
			
      /* if (!this.state.menu) {
        return false;
      }

      return this.state.menu && (!this.state.menu.active || !this.state.menu.first_available) */
    },

	redirectHandler () {
		var redirectToUnavailable = ['ecommerce', 'shop', 'flow-subscribed', 'flow-new', 'order-now', 'shop-by-tag', 'plans', 'unavailable']

		if (container.get('vue')) {
			let name = container.get('vue').$route.name;

      if (name === 'unavailable') {
        return true;
      }
      
			if (!this.isMenuAvailable()) {
				if (redirectToUnavailable.includes(name)) {
          container.get('vue').$router.push({ name: 'unavailable' })
					return true
				}
			}
		}

		return false
	},

    loadExtra () {
    	var records = this.state.freeExtra.config.filter(r => r.menuId === this.state.menu.id)
    	
    	this.state.freeExtra.ids = records && records.length > 0 ? records.map(r => r.extraId) : null

    	if (!this.state.freeExtra.ids) {

    		this.state.freeExtra.loaded = true
    		return Promise.resolve()
    	}

		var em = new ExtraApi()
		return em.all({
			params: {
				show: 10,
				page: 1,
				sort_direction: 'asc',
				query: 'id in (' + this.state.freeExtra.ids + ')'
			}
		})

		.then(response => {
			this.state.freeExtra.loaded = true

			const filterExtra = (r) => {
				return this.state.freeExtra.ids.includes(r.id) && r.stock > 0
			}

			var extra = response.body.data.resources.find(filterExtra)
			if (extra) {
				this.state.freeExtra.id = extra.id
				this.state.freeExtra.title = extra.title
				this.state.freeExtra.image = extra.images.big
			}
		})

		.catch(response => {
			this.state.freeExtra.loaded = true
		})
	},

	loadCurrentMenu (id, day) {

	    if (!id) {
	      id = window.user && window.user.order && window.user.order.week_plan && window.user.order.week_plan.id;
	    }


		// don't load if alredy started loading
		if (this.state.loading && this.state.loadingPromise) return this.state.loadingPromise

		// don't load if already loaded
		/*if (this.state.menu && this.state.menu.id == id && this.state.freeExtra.loaded) return Promise.resolve()*/

		this.state.loading = true

		var wm = new WeekPlanApi()

		let params = {}

		if (id) {
			params.id = id
		}

		if (day) {
			params.shipment_day = day
		}

		this.state.loadingPromise = wm.current(params)

		.then(response => {
			this.state.menu = new Menu(response.body.data.resource)

			if (!this.state.menu.active) {
				this.state.active = false
			}

			this.redirectHandler()
			
			return this.loadExtra()
		})

		.then(response => {
			this.state.loading = false
		})

		.catch(response => {
			this.state.loading = false
			return response
		})

		return this.state.loadingPromise;
	},

	// params: numberOfRecipes
	// return array of first Ids of menu e.g. [3,4,5]
	getMenuPrio (params) {
        if (!this.state.menu) {
            return
        }

        const sortByTag = (recipe_a, recipe_b) => {
        	return recipe_a.tags.find(tag => tag.name.toLowerCase() === this.config.boxTagName) ? 1 : -1
        }

        const isAlreadyHasBox = (menu) => {
        	return menu.find(recipe => recipe.tags.find(tag => tag.name.toLowerCase() === this.config.boxTagName))
        }

        var recipesSorted = []
        this.state.menu.recipes.forEach(recipe => recipesSorted.push(recipe))
        recipesSorted.sort(sortByTag)

        recipesSorted = recipesSorted.filter(recipe => {
        	return parseFloat(recipe.product.sell_out[2]) == 0;
        })

        var menuPrio = []
        for (let i = 0, count = 0; i < recipesSorted.length && count < params.numberOfRecipes; i++) {
            if (recipesSorted[i].available && !isAlreadyHasBox(menuPrio)) {
            	
                menuPrio.push(recipesSorted[i])
                count++
            }
        }
    
        return menuPrio.map(r => r.id)
    }
}